import ApiService from '@/services/api.service.js';
import i18n from "@/i18n";

export const LocalizationService = {

  languages: [],

  async init() {
    await this.getTranslations().then((response) => {
      this.languages = response.data.languages;

      for (let locale in response.data.translations) {
        let dictionary = response.data.translations[locale];

        // format for VeeValidate, expected format is:  validations.messages
        if (dictionary.validations !== undefined) {
          let validations = dictionary.validations;
          dictionary.validations = {};
          dictionary.validations.messages = validations;
        }

        i18n.mergeLocaleMessage(locale, dictionary)
      }
    })
  },

  getLanguages: function () {
    return ApiService.get('/language/languages');
  },

  getTranslations: function () {
    return ApiService.get('/language/translations');
  },

  getFormattedTranslations: function () {
    return ApiService.get('/language/translations/formatted');
  },

  updateTranslations: function (data) {
    return ApiService.post('/language/translations', data);
  },

  updateLanguages: function (data) {
    return ApiService.post('/language/languages', data);
  }
}

export default LocalizationService